import React from 'react'
import {
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'

export const Instructions: React.FC = () => {
  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        URL Swap - Bulk URL Migration
      </Typography>

      <Typography variant="body1" paragraph>
        URL Swap allows you to migrate content URLs in bulk by uploading a
        Google Spreadsheet containing your URL mappings.
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Requirements:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
              primary="Your spreadsheet must have two columns: 'old url' and 'new url'"
              secondary="Column names are case-insensitive and support variations like 'old_url', 'oldurl', etc."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Both columns must contain valid HTTP/HTTPS URLs"
              secondary="Empty rows will be skipped"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="The spreadsheet must be accessible via your Google Drive"
              secondary="Make sure you have permission to view the spreadsheet"
            />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Process:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="1. Authenticate with Google Drive" />
          </ListItem>
          <ListItem>
            <ListItemText primary="2. Paste your Google Sheets URL" />
          </ListItem>
          <ListItem>
            <ListItemText primary="3. Review and verify your URL mappings" />
          </ListItem>
          <ListItem>
            <ListItemText primary="4. Proceed with the URL swap operation" />
          </ListItem>
        </List>
      </Box>
    </Paper>
  )
}
